var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6 3.09601C6 3.09388 6 3.0909 6 3.08834C6 1.38272 4.65683 0 3 0C1.34317 0 0 1.38272 0 3.08834C0 4.60568 1.06303 5.86785 2.46455 6.12769L2.48276 6.13068V12.4675C2.48276 12.7615 2.71448 13 3 13C3.28552 13 3.51724 12.7615 3.51724 12.4675V6.13068C4.93448 5.8687 5.99669 4.61079 6 3.09643V3.09601ZM3 5.1194C1.91462 5.1194 1.03448 4.21335 1.03448 3.09601C1.03448 1.97867 1.91462 1.07261 3 1.07261C4.08538 1.07261 4.96552 1.97867 4.96552 3.09601C4.96428 4.21292 4.08497 5.11813 3 5.1194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWhite);
export default __webpack_public_path__ + "static/media/pin-white.87661e34c0724d4b767b979cf37b160c.svg";
export { ForwardRef as ReactComponent };